/**
 * Timeline widget: card background (CSS color).
 * Empty / null / undefined → fallback.
 *
 * @param {string|undefined|null} raw
 * @param {string} [fallback='#f8fafc']
 * @returns {string}
 */
export function resolveTimelineCardBg(raw, fallback = '#f8fafc') {
    const s = raw == null ? '' : String(raw).trim();
    return s === '' ? fallback : s;
}

/**
 * Timeline widget: full CSS `border` for the card (vertical + horizontal).
 *
 * @param {string|undefined|null} raw
 * @param {string} [fallback='#e2e8f0']
 * @returns {string}
 */
export function resolveTimelineCardBorderCss(raw, fallback = '#e2e8f0') {
    const s = raw == null || String(raw).trim() === '' ? fallback : String(raw).trim();
    const low = s.toLowerCase();
    if (low === 'none') return 'none';
    if (low === 'transparent') return '1px solid transparent';
    return `1px solid ${s}`;
}
